<template>
    <div>
        <Card>
            <Button type="primary" @click="SyncAllHandle" style="margin: 1rem;">全国区域同步</Button>
            <Table :columns="column" :data="list" size="small">
                <template slot-scope="{ index }" slot="Name">
                    <Select v-if="list[index].id !== '0'" v-model="list[index].id" filterable transfer
                    @on-change="SelectHandle(index)">
                        <Option v-for="item in SelectList[index - 1]" :value="item.id" :key="item.id">{{item.name}}</Option>
                    </Select>
                </template>
                <template slot-scope="{ index }" slot="Action">
                    <Button type="primary" ghost size="small" @click="SyncHandle(index)">同步</Button>
                </template>
            </Table>
        </Card>
    </div>
</template>

<script>
import { AddressSyncAddressInfoInitialization, AddressSyncAddressInfo, Address2SyncAddressInfoInitialization } from '@/api/DataSync'
export default {
  name: 'DataSync-AddressSync-AddressSync',
  data () {
    return {
      column: [
        {
          title: '级别',
          key: 'level',
          width: '90',
          align: 'center'
        },
        {
          title: '上级名称',
          slot: 'Name',
          minWidth: 150,
          maxWidth: 250,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '下级数量',
          key: 'ChildCount',
          width: 110,
          align: 'center'
        },
        {
          title: '最后更新时间',
          key: 'LogDate',
          width: 160,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'Action',
          width: 150,
          align: 'center'
        }
      ],
      list: [
        {
          id: '0',
          level: '省份',
          Name: '',
          ChildCount: 0,
          LogDate: ''
        },
        {
          id: '',
          level: '城市',
          Name: '',
          ChildCount: 0,
          LogDate: ''
        },
        {
          id: '',
          level: '区',
          Name: '',
          ChildCount: 0,
          LogDate: ''
        },
        {
          id: '',
          level: '镇',
          Name: '',
          ChildCount: 0,
          LogDate: ''
        }
      ],
      SelectList: []
    }
  },
  mounted: function () {
    this.DataInfoInitialization()
  },
  methods: {
    DataInfoInitialization () {
      AddressSyncAddressInfoInitialization().then(res => {
        if (res.IsSuccess) {
          this.SelectList.push(res.Data.Table)
          this.SelectList.push(res.Data.Table1)
          this.SelectList.push(res.Data.Table2)
          this.SelectList.push(res.Data.Table3)
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    SyncHandle (index) {
      const id = this.list[index].id
      if (id === '') {
        this.$Message.error('请先选择上级名称')
      } else {
        AddressSyncAddressInfo(id).then(res => {
          if (res.IsSuccess) {
            this.$Message.success('同步成功')
            this.list[index].ChildCount = res.Data.Table[0].ChildCount
            this.list[index].LogDate = res.Data.Table[0].LogDate
            if (index < 3) {
              if (res.Data.Table1.length > 0) {
                res.Data.Table1.forEach(item => {
                  let i = this.SelectList[index].findIndex(item1 => {
                    return item1.id === item.id
                  })
                  if (i === -1) {
                    this.SelectList[index].push(item)
                  } else {
                    this.SelectList[index][i] = item
                  }
                })
              }
            }
          } else {
            this.$Message.error(res.Message)
          }
        })
      }
    },
    SelectHandle (index) {
      const i = this.SelectList[index - 1].findIndex(item => {
        return item.id === this.list[index].id
      })
      if (i !== -1) {
        this.list[index].ChildCount = this.SelectList[index - 1][i].ChildCount
        this.list[index].LogDate = this.SelectList[index - 1][i].LogDate
      }
    },
    // 同步全国区域信息
    SyncAllHandle () {
      Address2SyncAddressInfoInitialization().then(res => {
        if (res.IsSuccess) {
          this.$Message.success('更新成功')
        } else {
          this.$Message.error('更新失败：' + res.Message)
        }
      })
    }
  }
}
</script>
